import React, { useState, useContext } from 'react';
import '../../../../../assets/css/subscreens/serviceprovider/dashboard/providerunavailable/UnavailableScreen.css';
import { User, Minus, Check } from 'lucide-react';
import AppContext from '../../../../../context/AppContext';
import axios from 'axios';
const UnavailableScreen = ({  availablity, setAvailability }) => {
  const [internalAvailable, setInternalAvailable] = useState(false);
  const [connecting, setConnecting] = useState(false);
  const { baseUrl } = useContext(AppContext);

  const isAvailable = availablity !== undefined ? availablity : internalAvailable;

  const handleClick = () => {

   const authToken = localStorage.getItem("authToken");

   setConnecting(true);

   const formData = new FormData();

   formData.append("availablity", 1);

   axios.post(
      `${baseUrl}/worker/updatesetting`,
      formData,
      {
         headers:{
            Authorization:`Bearer ${authToken}`
         }
      }
   )
   .then(() => {

      localStorage.setItem(
         "availability",
         "1"
      );

      setAvailability(true);

   })
   .catch(err => {
      console.log(err);
   })
   .finally(() => {
      setConnecting(false);
   });

};

  return (
    <div className="us-page">

      {/* Illustration */}
      <div className="us-illustration">
        {isAvailable ? (
          <svg viewBox="0 0 400 130" className="us-plug-svg">
            {/* connected cable - one smooth line */}
            <path d="M0 75 Q 100 30, 200 75 T 400 75" stroke="#484745" strokeWidth="5" fill="none" strokeLinecap="round" />

            {/* left plug body */}
            <rect x="178" y="55" width="42" height="42" rx="8" fill="#f4f3f1" stroke="#484745" strokeWidth="3.5" />
            <rect x="182" y="59" width="34" height="34" rx="5" fill="#ffffff" stroke="#bdbab4" strokeWidth="1" />
            <line x1="188" y1="69" x2="210" y2="69" stroke="#484745" strokeWidth="2.5" />
            <line x1="188" y1="76" x2="210" y2="76" stroke="#484745" strokeWidth="2.5" />
            <line x1="188" y1="83" x2="210" y2="83" stroke="#484745" strokeWidth="2.5" />

            {/* connection joint */}
            <rect x="196" y="62" width="8" height="28" fill="#484745" />
          </svg>
        ) : connecting ? (
          <svg viewBox="0 0 400 130" className="us-plug-svg us-plug-svg--connecting">
            {/* pulsing spark lines while connecting */}
            <line className="us-spark" x1="200" y1="14" x2="200" y2="0" stroke="#0491e1" strokeWidth="3" strokeLinecap="round" />
            <line className="us-spark" x1="172" y1="22" x2="160" y2="8" stroke="#0491e1" strokeWidth="3" strokeLinecap="round" />
            <line className="us-spark" x1="228" y1="22" x2="240" y2="8" stroke="#0491e1" strokeWidth="3" strokeLinecap="round" />
            <line className="us-spark" x1="155" y1="40" x2="140" y2="32" stroke="#0491e1" strokeWidth="3" strokeLinecap="round" />
            <line className="us-spark" x1="245" y1="40" x2="260" y2="32" stroke="#0491e1" strokeWidth="3" strokeLinecap="round" />

            {/* left cable */}
            <path d="M0 75 Q 90 28, 178 75" stroke="#484745" strokeWidth="5" fill="none" strokeLinecap="round" />

            {/* left plug - sliding closer */}
            <g className="us-plug-left">
              <rect x="118" y="58" width="34" height="36" rx="8" fill="#f4f3f1" stroke="#484745" strokeWidth="3.5" />
              <rect x="122" y="62" width="26" height="28" rx="4" fill="#ffffff" stroke="#bdbab4" strokeWidth="1" />
              <line x1="127" y1="70" x2="143" y2="70" stroke="#484745" strokeWidth="2" />
              <line x1="127" y1="76" x2="143" y2="76" stroke="#484745" strokeWidth="2" />
              <line x1="127" y1="82" x2="143" y2="82" stroke="#484745" strokeWidth="2" />
              <rect x="148" y="68" width="14" height="6" rx="2" fill="#484745" />
              <rect x="148" y="80" width="14" height="6" rx="2" fill="#484745" />
            </g>

            {/* right plug - sliding closer */}
            <g className="us-plug-right">
              <rect x="248" y="58" width="34" height="36" rx="8" fill="#f4f3f1" stroke="#484745" strokeWidth="3.5" />
              <rect x="252" y="62" width="26" height="28" rx="4" fill="#ffffff" stroke="#bdbab4" strokeWidth="1" />
              <line x1="257" y1="70" x2="273" y2="70" stroke="#484745" strokeWidth="2" />
              <line x1="257" y1="78" x2="273" y2="78" stroke="#484745" strokeWidth="2" />
              <rect x="234" y="68" width="14" height="6" rx="2" fill="#ffffff" stroke="#484745" strokeWidth="2" />
              <rect x="234" y="80" width="14" height="6" rx="2" fill="#ffffff" stroke="#484745" strokeWidth="2" />
            </g>

            {/* right cable */}
            <path d="M282 75 Q 310 28, 400 75" stroke="#484745" strokeWidth="5" fill="none" strokeLinecap="round" />
          </svg>
        ) : (
          <svg viewBox="0 0 400 130" className="us-plug-svg">
            {/* spark lines */}
            <line x1="200" y1="14" x2="200" y2="0" stroke="#484745" strokeWidth="3" strokeLinecap="round" />
            <line x1="172" y1="22" x2="160" y2="8" stroke="#484745" strokeWidth="3" strokeLinecap="round" />
            <line x1="228" y1="22" x2="240" y2="8" stroke="#484745" strokeWidth="3" strokeLinecap="round" />
            <line x1="155" y1="40" x2="140" y2="32" stroke="#484745" strokeWidth="3" strokeLinecap="round" />
            <line x1="245" y1="40" x2="260" y2="32" stroke="#484745" strokeWidth="3" strokeLinecap="round" />

            {/* left cable */}
            <path d="M0 75 Q 80 28, 148 75" stroke="#484745" strokeWidth="5" fill="none" strokeLinecap="round" />

            {/* left plug - male connector */}
            <rect x="118" y="58" width="34" height="36" rx="8" fill="#f4f3f1" stroke="#484745" strokeWidth="3.5" />
            <rect x="122" y="62" width="26" height="28" rx="4" fill="#ffffff" stroke="#bdbab4" strokeWidth="1" />
            <line x1="127" y1="70" x2="143" y2="70" stroke="#484745" strokeWidth="2" />
            <line x1="127" y1="76" x2="143" y2="76" stroke="#484745" strokeWidth="2" />
            <line x1="127" y1="82" x2="143" y2="82" stroke="#484745" strokeWidth="2" />
            {/* prongs sticking out */}
            <rect x="148" y="68" width="14" height="6" rx="2" fill="#484745" />
            <rect x="148" y="80" width="14" height="6" rx="2" fill="#484745" />

            {/* right plug - female connector */}
            <rect x="248" y="58" width="34" height="36" rx="8" fill="#f4f3f1" stroke="#484745" strokeWidth="3.5" />
            <rect x="252" y="62" width="26" height="28" rx="4" fill="#ffffff" stroke="#bdbab4" strokeWidth="1" />
            <line x1="257" y1="70" x2="273" y2="70" stroke="#484745" strokeWidth="2" />
            <line x1="257" y1="78" x2="273" y2="78" stroke="#484745" strokeWidth="2" />
            {/* socket holes */}
            <rect x="234" y="68" width="14" height="6" rx="2" fill="#ffffff" stroke="#484745" strokeWidth="2" />
            <rect x="234" y="80" width="14" height="6" rx="2" fill="#ffffff" stroke="#484745" strokeWidth="2" />

            {/* right cable */}
            <path d="M282 75 Q 320 28, 400 75" stroke="#484745" strokeWidth="5" fill="none" strokeLinecap="round" />
          </svg>
        )}
      </div>

      {/* Title row */}
      <div className="us-title-row">
        <div className={`us-person-icon ${isAvailable || connecting ? 'us-person-icon--ok' : ''}`}>
          <User size={26} strokeWidth={2.2} />
          <span className={`us-person-badge ${isAvailable || connecting ? 'us-person-badge--ok' : ''}`}>
            {isAvailable
              ? <Check size={10} strokeWidth={3} color="#ffffff" />
              : <Minus size={10} strokeWidth={3} color="#ffffff" />
            }
          </span>
        </div>
        <h1 className="us-heading">
          {connecting ? 'Connecting...' : (isAvailable ? 'Available' : 'Unavailable')}
        </h1>
      </div>

      {/* Subheading */}
      <h2 className="us-subheading">
        {connecting
          ? 'Switching your status to available'
          : (isAvailable ? 'You are currently available' : 'You are currently unavailable')}
      </h2>

      {/* Description */}
      <p className="us-desc">
        {connecting ? (
          <>
            Please wait while we update your availability
            and load your job requests.
          </>
        ) : isAvailable ? (
          <>
            Your status is set to available, so you will receive new job
            requests and can access the jobs page.
            <br />
            Switch your status to unavailable if you want to pause receiving jobs.
          </>
        ) : (
          <>
            Since your status is set to unavailable, you will not receive
            any new job requests and cannot access the jobs page.
            <br />
            Please change your status to available to view and manage jobs.
          </>
        )}
      </p>

      {/* Button */}
      <button
        className={`us-btn ${isAvailable ? 'us-btn--available' : ''} ${connecting ? 'us-btn--loading' : ''}`}
        onClick={handleClick}
        disabled={connecting}
      >
        {connecting ? (
          <>
            <span className="us-spinner" />
            Connecting...
          </>
        ) : (
          <>
            <span className="us-btn-icon">
              {isAvailable
                ? <Minus size={14} strokeWidth={3} />
                : <Check size={14} strokeWidth={3} />
              }
            </span>
            {isAvailable ? 'Mark as Unavailable' : 'Available'}
          </>
        )}
      </button>

    </div>
  );
};

export default UnavailableScreen;